// todo this will be a global mixing with an accessible method
import Axios from "axios";
import EventBus from "../EventBus";

export const sharedQueries = {

    data() {
        return {
            serviceRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}`,
            resourcePath: '/odata/CustomerSearch?$filter=',
            queryConcatAnd: '+and+',
            queryConcatOr: '+or+',
            finalQuery: '',
        }
    },
    created() {
    },
    methods: {
        getBranchBillingAndDeliveryDetails(branchCode) {

            let baseQueryUri = this.serviceRouteUrl + this.resourcePath
            const searchString = 'ref eq \'' + branchCode + '\'+and+status+eq+\'ACTIVE\'&skip=0&top=1'

            return this.finalQuery = baseQueryUri + searchString

            console.log(this.finalQuery)

        }

    }
}